/* eslint-disable react/prop-types */
import React from 'react'
import { Divider } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'
import { IApplication } from '../../model/Applications'
import MikeCloudApp from './MikeCloudApp'
import AppsSkeleton from './AppsSkeleton'
import { useMatch } from 'react-router-dom'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    mediumGrey?: { main: string; light: string }
  }
}

interface IProps {
  applications: Array<IApplication>
  loading: boolean
  projectId: string
  tenantId: string
}

// As many columns as fit at the tile's minimum width, stretched to share the
// full width so there is no side gutter. The gap does the spacing, so no row
// carries trailing padding.
const StyledContainer = styled('div')(({ theme }) => {
  const t = theme as MikeTheme
  return {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fill, minmax(${theme.spacing(16)}, 1fr))`,
    justifyItems: 'center',
    // Top-aligned so every icon box sits on the same line; a name that wraps
    // grows its tile downwards instead of lifting the icon.
    alignItems: 'start',
    columnGap: theme.spacing(6),
    rowGap: theme.spacing(3),
    padding: '30px',
    backgroundColor: t.palette.mediumGrey?.light,
    border: '1px solid ' + t.palette.mediumGrey?.main
  }
})

const MikeCloudApps = (props: IProps) => {
  const { applications, loading, projectId, tenantId } = props

  const match = useMatch({
    path: '/project/:id',
    end: true,
    caseSensitive: true
  })

  const enabledApplications = applications.filter(
    (app: IApplication) => app.enabled
  )

  if (loading) {
    return <AppsSkeleton />
  }

  // The container carries its own padding and border, so with nothing to show
  // it would leave a tall empty band between the nav tabs.
  if (enabledApplications.length === 0) {
    return <Divider />
  }

  return (
    <StyledContainer>
      {enabledApplications.map((app: IApplication, index: number) => (
        <MikeCloudApp
          key={index}
          application={app}
          projectId={projectId}
          linkToRootUrl={!match}
          tenantId={tenantId}
        />
      ))}
    </StyledContainer>
  )
}

export default MikeCloudApps
